import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=0029a3ca&scoped=true&"
import script from "./EditTask.vue?vue&type=script&lang=js&"
export * from "./EditTask.vue?vue&type=script&lang=js&"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=0029a3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029a3ca",
  null
  
)

export default component.exports